// use @under_construction.js @shared_header.js @dashboardfooter.js

// # Neo Mentee Step 2 Component
import React, { useEffect, useState } from 'react';
import { Link, useNavigate, Routes, Route, useParams } from 'react-router-dom';
import { useAuthStore } from '../../auth/state';
import sessionManager from '../../auth/session';
import DashboardHeader from '../../components/DashboardHeader';  // # Updated import
import DashboardFooter from '../../components/DashboardFooter';
import ProtectedRouteUser from '../../routes/protected/protected_route_user';
import ProtectedRouteAdmin from '../../routes/protected/protected_route_admin';
import UWorldQBank from './qbanks2/uw2';  // # Import Step 2 UWorld component
import AmbossQBank from './qbanks2/amboss2';  // # Import Step 2 Amboss component
import NBMEQBank from './qbanks2/nbme2';  // # Import Step 2 NBME component
import Tasks2 from './tutora2/tasks2';
import MentorNotes2 from './tutora2/mentor_notes2';
import Checklist2 from './management2/checklist2';
import Dedicated2 from './management2/dedicated2';
import MenteeMeetings2 from './management2/mentee_meetings2';
import WeakSpots2 from './management2/weakspots2';
import Assignments2 from './assignments2/assignments2';
import MenteeStats2 from './M_stats2/mentee_stats2'; // # Import the Stats component
// # Import new components
import GiveAssignment2 from './assignments2/give_assign2';
import DedicatedTasks2 from './tutora2/give_dedic2';
// # Import missing components
import M2Calendar from './mentoring2/m2_calendar';
import NeoTime from '../common/neo_time';
import Counter2 from './mentoring2/counter2';
import Counter2Page from './mentoring2/counter2_page';
import TaskChapter2 from './tutora2/task_chapter2'; // # Import TaskChapter2 component
// # Import Firebase
import { doc, getDoc, setDoc, updateDoc, collection, query, where, getDocs } from 'firebase/firestore';
import { db } from '../../firebase/config';
import './neo_mentee_step2.css';
import cacheManager from '../../auth/cache_manager';  // # Import cache manager

// # Import icons
import { 
  FaCalendarAlt, 
  FaClock,
  FaBook,
  FaClipboardCheck,
  FaChartLine,
  FaTasks,
  FaUserClock,
  FaListAlt,
  FaUserMd,
  FaExclamationTriangle,
  FaCalendarCheck,
  FaRegCircle,
  FaBookMedical,
  // # Import new icons
  FaQuestionCircle,
  FaFire,
  FaUser,
  FaEnvelope,
  FaPhone,
  FaFlag
} from 'react-icons/fa';
import { RiNumber100 } from 'react-icons/ri';

// # Import mentee icons
import calendarIcon from '../../aneo_media/mentee/calendar.png';
import timeIcon from '../../aneo_media/mentee/time.png';
import uworldIcon from '../../aneo_media/mentee/uworld.png';
import ambossIcon from '../../aneo_media/mentee/amboss.png';
import nbmeIcon from '../../aneo_media/mentee/NBME.png';
import counterIcon from '../../aneo_media/mentee/counter.png';
import assignmentIcon from '../../aneo_media/mentee/assignment.png';
import weaknessIcon from '../../aneo_media/mentee/weakness.png';
import dedicatedIcon from '../../aneo_media/mentee/dedicated.png';
import meetingIcon from '../../aneo_media/mentee/meeting.png';
import checklistIcon from '../../aneo_media/mentee/checklist.png';
import tasksIcon from '../../aneo_media/mentee/tasks.png';
import notesIcon from '../../aneo_media/mentee/notes.png';
import menteeCover from '../../aneo_media/mentee/mentee_cover.jpg';

// # Import components
import MenteeGuide from '../common/mentee_guide';

// # Mentor Card Component
const MentorCard = ({ userId }) => {
  const [mentorData, setMentorData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [mentorId, setMentorId] = useState(null);

  // # Fetch mentee document to get mentor ID
  useEffect(() => {
    const fetchMentorId = async () => {
      try {
        if (!userId) return;
        
        // # Get mentee document to find mentor ID
        const menteeDocRef = doc(db, 's2_mentee', userId);
        const menteeDoc = await getDoc(menteeDocRef);
        
        if (menteeDoc.exists()) {
          const menteeData = menteeDoc.data();
          const currentMentorId = menteeData.mentorship?.currentMentor;
          
          if (currentMentorId) {
            setMentorId(currentMentorId);
          } else {
            setLoading(false);
          }
        } else {
          setLoading(false);
        }
      } catch (error) {
        console.error('Error fetching mentor ID:', error);
        setLoading(false);
      }
    };
    
    fetchMentorId();
  }, [userId]);

  // # Fetch mentor data once we have the mentor ID
  useEffect(() => {
    const fetchMentorData = async () => {
      try {
        if (!mentorId) return;
        
        // # Get mentor user document
        const mentorDocRef = doc(db, 'users', mentorId);
        const mentorDoc = await getDoc(mentorDocRef);
        
        if (mentorDoc.exists()) {
          setMentorData(mentorDoc.data());
        }
        
        setLoading(false);
      } catch (error) {
        console.error('Error fetching mentor data:', error);
        setLoading(false);
      }
    };
    
    if (mentorId) {
      fetchMentorData();
    }
  }, [mentorId]);

  // # If no mentor assigned yet
  if (!loading && !mentorData) {
    return (
      <div className="neo_ment2_mentor_card neo_ment2_no_mentor">
        <div className="neo_ment2_mentor_header">
          <h3>My Mentor</h3>
        </div>
        <div className="neo_ment2_no_mentor_content">
          <FaUserMd className="neo_ment2_no_mentor_icon" />
          <p>No mentor assigned yet</p>
        </div>
      </div>
    );
  }

  // # Loading state
  if (loading) {
    return (
      <div className="neo_ment2_mentor_card">
        <div className="neo_ment2_mentor_header">
          <h3>My Mentor</h3>
        </div>
        <div className="neo_ment2_loading">
          <p>Loading mentor information...</p>
        </div>
      </div>
    );
  }

  // # Get profile photo URL or default to pfp.png
  const mentorPhotoUrl = mentorData?.photoURL || '/icons/pfp.png';

  return (
    <div className="neo_ment2_mentor_card">
      <div className="neo_ment2_mentor_header">
        <h3>My Mentor</h3>
      </div>
      <div className="neo_ment2_mentor_content">
        <div className="neo_ment2_mentor_avatar">
          <img 
            src={mentorPhotoUrl} 
            alt="Mentor" 
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = '/icons/pfp.png';
            }}
          />
        </div>
        <div className="neo_ment2_mentor_details">
          <h4>{mentorData.firstName} {mentorData.middleName} {mentorData.lastName}</h4>
          
          <div className="neo_ment2_mentor_info_grid">
            <div className="neo_ment2_mentor_info_item">
              <FaUser className="neo_ment2_mentor_info_icon" />
              <span>{mentorData.gender ? mentorData.gender.charAt(0).toUpperCase() + mentorData.gender.slice(1) : 'N/A'}</span>
            </div>
            
            <div className="neo_ment2_mentor_info_item">
              <FaEnvelope className="neo_ment2_mentor_info_icon" />
              <span>{mentorData.email || 'N/A'}</span>
            </div>
            
            <div className="neo_ment2_mentor_info_item">
              <FaPhone className="neo_ment2_mentor_info_icon" />
              <span>
                {mentorData.selectedCountry?.code || ''} {mentorData.phoneNumber || 'N/A'}
              </span>
            </div>
            
            <div className="neo_ment2_mentor_info_item">
              <FaFlag className="neo_ment2_mentor_info_icon" />
              <span>{mentorData.nationality || 'N/A'}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

// # Add helper function to get the correct user ID for database operations
const getTargetUserId = (isAdmin, viewingMenteeId, currentUserId) => {
  // Always return mentee ID if we have one, otherwise return current user ID
  return viewingMenteeId || currentUserId;
};

// # Add helper function to get mentee data
const getMenteeData = async (menteeId) => {
  if (!menteeId) return null;
  
  try {
    const menteeRef = doc(db, 'db2_mentee', menteeId);
    const menteeDoc = await getDoc(menteeRef);
    return menteeDoc.exists() ? menteeDoc.data() : null;
  } catch (error) {
    console.error('Error fetching mentee data:', error);
    return null;
  }
};

// # Add helper function to update mentee data
const updateMenteeData = async (menteeId, data) => {
  if (!menteeId) return;
  
  try {
    const menteeRef = doc(db, 'db2_mentee', menteeId);
    await setDoc(menteeRef, data, { merge: true });
  } catch (error) {
    console.error('Error updating mentee data:', error);
  }
};

function NeoMenteeStep2({ isAdmin, isMentorView }) {
  const navigate = useNavigate();
  const { userProfile, user } = useAuthStore();
  const currentStep = 'step2';
  const { username } = useParams(); // # Get username from URL params
  const [isDarkMode, setIsDarkMode] = useState(false);  // # Add dark mode state
  
  // # Create base path based on admin/mentor status
  let basePath = '/mentorship';
  if (isAdmin) {
    basePath = '/admin/mentorship';
  }
  if (isMentorView && username) {
    basePath = `/mentor/${currentStep}/${username}`;
  }

  // # State to store the mentee ID when admin is viewing a specific mentee
  const [viewingMenteeId, setViewingMenteeId] = useState(null);
  const [viewingMenteeData, setViewingMenteeData] = useState(null);

  // # Load theme preference from user data on initial render
  useEffect(() => {
    const loadThemePreference = async () => {
      if (user && user.uid) {
        // # Try to get from cache first
        const userData = cacheManager.get(`user_${user.uid}`);
        if (userData && userData.themes && userData.themes.gen_theme !== undefined) {
          setIsDarkMode(userData.themes.gen_theme === 'dark');
        }
      }
    };
    
    loadThemePreference();
  }, [user]);

  // # Handle theme toggle
  const handleThemeToggle = async () => {
    try {
      const newTheme = !isDarkMode;
      setIsDarkMode(newTheme);
      
      // # Update theme in Firebase if user is logged in
      if (user && user.uid) {
        // # Update the user document
        await updateDoc(doc(db, 'users', user.uid), {
          'themes.gen_theme': newTheme ? 'dark' : 'light'
        });
        
        // # Update cache manager
        const userData = cacheManager.get(`user_${user.uid}`);
        if (userData) {
          const updatedUserData = {
            ...userData,
            themes: {
              ...(userData.themes || {}),
              gen_theme: newTheme ? 'dark' : 'light'
            }
          };
          cacheManager.set(`user_${user.uid}`, updatedUserData);
        }
      }
    } catch (error) {
      console.error('Error updating theme preference:', error);
    }
  };

  // # Fetch mentee data by username when in mentor view
  useEffect(() => {
    const fetchMenteeByUsername = async () => {
      if (isMentorView && username) {
        try {
          // # Query users collection for the username
          const usersCollection = collection(db, 'users');
          const q = query(usersCollection, where('username', '==', username));
          const querySnapshot = await getDocs(q);
          
          if (!querySnapshot.empty) {
            const userData = querySnapshot.docs[0].data();
            const userId = querySnapshot.docs[0].id;
            setViewingMenteeId(userId);
            setViewingMenteeData(userData);
            // # Store mentee ID in sessionStorage for other components
            sessionStorage.setItem('currentViewingMenteeId', userId);
          } else {
            console.error('No user found with username:', username);
            // # If no user found, redirect to dashboard
            navigate('/dashboard');
          }
        } catch (error) {
          console.error('Error fetching mentee by username:', error);
        }
      }
    };
    
    fetchMenteeByUsername();
  }, [isMentorView, username, navigate]);

  // # Check if admin is viewing a specific mentee (original code)
  useEffect(() => {
    if (isAdmin && !isMentorView) {
      // # Get the source of navigation from sessionStorage
      const navigationSource = sessionStorage.getItem('menteeNavigationSource');
      const menteeId = sessionStorage.getItem('currentViewingMenteeId');
      
      // # If coming from mentees_list.js, use the mentee ID
      if (navigationSource === 'mentees_list' && menteeId) {
        setViewingMenteeId(menteeId);
        
        // # Fetch basic mentee data to display in the UI
        const fetchMenteeData = async () => {
          try {
            const menteeDocRef = doc(db, 'users', menteeId);
            const menteeDoc = await getDoc(menteeDocRef);
            
            if (menteeDoc.exists()) {
              setViewingMenteeData(menteeDoc.data());
            }
          } catch (error) {
            console.error('Error fetching mentee data:', error);
          }
        };
        
        fetchMenteeData();
      } else if (navigationSource === 'admin_dashboard') {
        // # If coming from admin_dashboard.js, clear any existing mentee ID
        // # This ensures admin sees their own content
        setViewingMenteeId(null);
        setViewingMenteeData(null);
        sessionStorage.removeItem('currentViewingMenteeId');
      } else if (menteeId) {
        // # For backward compatibility, handle existing code path
        setViewingMenteeId(menteeId);
        
        // # Fetch basic mentee data to display in the UI
        const fetchMenteeData = async () => {
          try {
            const menteeDocRef = doc(db, 'users', menteeId);
            const menteeDoc = await getDoc(menteeDocRef);
            
            if (menteeDoc.exists()) {
              setViewingMenteeData(menteeDoc.data());
            }
          } catch (error) {
            console.error('Error fetching mentee data:', error);
          }
        };
        
        fetchMenteeData();
      }
    }
  }, [isAdmin, navigate]);

  // # No need for subscription check here as it's handled by ProtectedRouteUser
  useEffect(() => {
    if (!user?.uid && !viewingMenteeId && !isMentorView) {
      navigate('/signin');
    }
  }, [user, navigate, viewingMenteeId, isMentorView]);

  // # Group dashboard items into sections
  const dashboardSections = {
    time: {
      title: 'Time & Stats',
      items: [
        {
          title: 'Tasks Calendar',
          icon: calendarIcon,
          path: isMentorView ? `calendar` : `${basePath}/${currentStep}/calendar`
        },
        {
          title: 'Meetings',
          icon: meetingIcon,
          path: isMentorView ? `meetings` : `${basePath}/${currentStep}/meetings`
        },
        {
          title: 'Time Tracking',
          icon: timeIcon,
          path: isMentorView ? `time` : `${basePath}/${currentStep}/time`
        },
        {
          title: 'Stats Dashboard',
          icon: <FaChartLine className="neo_ment2_react_icon" style={{ color: '#4CAF50' }} />,
          path: isMentorView ? `stats` : `${basePath}/${currentStep}/stats`
        }
      ]
    },
    qbanks: {
      title: 'Question Banks & Resources',
      items: [
        {
          title: 'UWORLD',
          icon: uworldIcon,
          path: isMentorView ? `uworld` : `${basePath}/${currentStep}/uworld`
        },
        {
          title: 'Amboss',
          icon: ambossIcon,
          path: isMentorView ? `amboss` : `${basePath}/${currentStep}/amboss`
        },
        {
          title: 'NBME',
          icon: nbmeIcon,
          path: isMentorView ? `nbme` : `${basePath}/${currentStep}/nbme`
        },
        {
          title: 'Mistake Counter',
          icon: counterIcon,
          path: isMentorView ? `mentoring2/counter2` : `${basePath}/${currentStep}/mentoring2/counter2`
        },
        {
          title: 'Mentee Guide',
          icon: <FaBookMedical className="neo_ment2_react_icon" style={{ color: '#2196F3' }} />,
          path: isMentorView ? `mentee-guide` : `${basePath}/${currentStep}/mentee-guide`
        }
      ]
    },
    management: {
      title: 'Management',
      items: [
        {
          title: 'Assignments',
          icon: assignmentIcon,
          path: isMentorView ? `assignments` : `${basePath}/${currentStep}/assignments`
        },
        {
          title: 'Weak Spots',
          icon: weaknessIcon,
          path: isMentorView ? `weakspots` : `${basePath}/${currentStep}/weakspots`
        },
        {
          title: 'Dedicated Plan',
          icon: dedicatedIcon,
          path: isMentorView ? `plan` : `${basePath}/${currentStep}/plan`
        },
        {
          title: 'Checklist',
          icon: checklistIcon,
          path: isMentorView ? `checklist` : `${basePath}/${currentStep}/checklist`
        }
      ]
    },
    mentor: {
      title: 'Mentor Section',
      items: [
        {
          title: 'Tasks',
          icon: tasksIcon,
          path: isMentorView ? `tasks` : `${basePath}/${currentStep}/tasks`
        },
        {
          title: 'Mentor Notes',
          icon: notesIcon,
          path: isMentorView ? `notes` : `${basePath}/${currentStep}/notes`
        },
        // # Add new items
        {
          title: 'Give Assignment',
          icon: <FaQuestionCircle className="neo_ment2_react_icon" style={{ color: '#FF5722' }} />,
          path: isMentorView ? `give-assignment` : `${basePath}/${currentStep}/give-assignment`
        },
        {
          title: 'Dedicated Tasks',
          icon: <FaFire className="neo_ment2_react_icon" style={{ color: '#FF9800' }} />,
          path: isMentorView ? `dedicated-tasks` : `${basePath}/${currentStep}/dedicated-tasks`
        }
      ]
    }
  };

  // # Get profile photo URL or default to pfp.png
  const profilePhotoUrl = isAdmin && viewingMenteeData 
    ? viewingMenteeData?.photoURL || '/icons/pfp.png'
    : userProfile?.photoURL || '/icons/pfp.png';

  return (
    <div className={`neo_ment2_container ${isDarkMode ? 'neo_ment2_dark-mode' : ''}`}>
      <Routes>
        {/* # Main dashboard view */}
        <Route 
          path="/" 
          element={
            <ProtectedRouteUser requiredSubscription="step2_mentorship">
              <>
                <DashboardHeader isDarkMode={isDarkMode} onThemeToggle={handleThemeToggle} />
                <div className="neo_ment2_profile_section">
                  <div className="neo_ment2_cover_image">
                    <img src={menteeCover} alt="Cover" />
                  </div>
                  {/* # Step Indicator */}
                  <div className="neo_ment2_step_indicator">
                    <FaRegCircle className="neo_ment2_step_icon" />
                    <span>STEP 2</span>
                  </div>
                  <div className="neo_ment2_profile_info">
                    <div className="neo_ment2_avatar">
                      <img 
                        src={profilePhotoUrl} 
                        alt="Profile"
                        onError={(e) => {
                          e.target.onerror = null;
                          e.target.src = '/icons/pfp.png';
                        }}
                      />
                    </div>
                    <div className="neo_ment2_details">
                      {isAdmin && viewingMenteeData ? (
                        <>
                          <h2>
                            {viewingMenteeData?.firstName} {viewingMenteeData?.middleName} {viewingMenteeData?.lastName}
                            <span className="neo_ment2_viewing_badge">Viewing as Mentor</span>
                          </h2>
                          <p>@{viewingMenteeData?.username}</p>
                        </>
                      ) : (
                        <>
                          <h2>{userProfile?.firstName} {userProfile?.middleName} {userProfile?.lastName}</h2>
                          <p>@{userProfile?.username}</p>
                        </>
                      )}
                    </div>
                  </div>
                </div>

                <div className="neo_ment2_dashboard_sections">
                  {/* # Add Mentor Card Section */}
                  <div className="neo_ment2_section neo_ment2_mentor_section">
                    {isMentorView ? (
                      // # When in mentor view, show card with current user (mentor) data
                      <div className="neo_ment2_mentor_card">
                        <div className="neo_ment2_mentor_header">
                          <h3>Mentor Profile</h3>
                        </div>
                        <div className="neo_ment2_mentor_content">
                          <div className="neo_ment2_mentor_avatar">
                            <img 
                              src={userProfile?.photoURL || '/icons/pfp.png'} 
                              alt="Mentor" 
                              onError={(e) => {
                                e.target.onerror = null;
                                e.target.src = '/icons/pfp.png';
                              }}
                            />
                          </div>
                          <div className="neo_ment2_mentor_details">
                            <h4>{userProfile?.firstName} {userProfile?.middleName} {userProfile?.lastName}</h4>
                            
                            <div className="neo_ment2_mentor_info_grid">
                              <div className="neo_ment2_mentor_info_item">
                                <FaUser className="neo_ment2_mentor_info_icon" />
                                <span>{userProfile?.gender ? userProfile.gender.charAt(0).toUpperCase() + userProfile.gender.slice(1) : 'N/A'}</span>
                              </div>
                              
                              <div className="neo_ment2_mentor_info_item">
                                <FaEnvelope className="neo_ment2_mentor_info_icon" />
                                <span>{userProfile?.email || 'N/A'}</span>
                              </div>
                              
                              <div className="neo_ment2_mentor_info_item">
                                <FaPhone className="neo_ment2_mentor_info_icon" />
                                <span>{userProfile?.selectedCountry?.code || ''} {userProfile?.phoneNumber || 'N/A'}</span>
                              </div>
                              
                              <div className="neo_ment2_mentor_info_item">
                                <FaFlag className="neo_ment2_mentor_info_icon" />
                                <span>{userProfile?.nationality || 'N/A'}</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    ) : (
                      // # When not in mentor view, show normal mentee's assigned mentor card
                      <MentorCard userId={isAdmin && viewingMenteeId ? viewingMenteeId : user?.uid} />
                    )}
                  </div>
                  
                  {Object.entries(dashboardSections).map(([key, section]) => (
                    // # Only show mentor section to admins, show all other sections to everyone
                    (key === 'mentor' && !isAdmin) ? null : (
                      <div key={key} className="neo_ment2_section">
                        <h3 className="neo_ment2_section_title">{section.title}</h3>
                        <div className="neo_ment2_section_grid">
                          {section.items.map((item, index) => (
                            <Link 
                              key={index} 
                              to={item.path}
                              className="neo_ment2_dashboard_item"
                            >
                              <div className="neo_ment2_item_icon">
                                {typeof item.icon === 'string' ? (
                                  <img src={item.icon} alt={item.title} />
                                ) : (
                                  item.icon
                                )}
                              </div>
                              <h3>{item.title}</h3>
                            </Link>
                          ))}
                        </div>
                      </div>
                    )
                  ))}
                </div>

                <DashboardFooter isDarkMode={isDarkMode} />
              </>
            </ProtectedRouteUser>
          } 
        />

        {/* # Stats route */}
        <Route 
          path="stats" 
          element={
            isAdmin ? (
              <MenteeStats2 isAdmin={isAdmin} menteeId={viewingMenteeId} />
            ) : (
              <ProtectedRouteUser requiredSubscription="step2_mentorship">
                <MenteeStats2 isAdmin={isAdmin} />
              </ProtectedRouteUser>
            )
          } 
        />
        
        {/* # QBank routes - Protected by ProtectedRouteUser for users */}
        <Route 
          path="uworld" 
          element={
            isAdmin ? (
              <UWorldQBank isAdmin={isAdmin} menteeId={viewingMenteeId} />
            ) : (
              <ProtectedRouteUser requiredSubscription="step2_mentorship">
                <UWorldQBank isAdmin={isAdmin} />
              </ProtectedRouteUser>
            )
          } 
        />
        
        <Route 
          path="amboss" 
          element={
            isAdmin ? (
              <AmbossQBank isAdmin={isAdmin} menteeId={viewingMenteeId} />
            ) : (
              <ProtectedRouteUser requiredSubscription="step2_mentorship">
                <AmbossQBank isAdmin={isAdmin} />
              </ProtectedRouteUser>
            )
          } 
        />
        
        <Route 
          path="nbme" 
          element={
            isAdmin ? (
              <NBMEQBank isAdmin={isAdmin} menteeId={viewingMenteeId} />
            ) : (
              <ProtectedRouteUser requiredSubscription="step2_mentorship">
                <NBMEQBank isAdmin={isAdmin} />
              </ProtectedRouteUser>
            )
          } 
        />
        
        {/* # Management routes */}
        <Route 
          path="tasks" 
          element={
            isAdmin ? (
              <Tasks2 isAdmin={isAdmin} menteeId={viewingMenteeId} />
            ) : (
              <ProtectedRouteUser requiredSubscription="step2_mentorship">
                <Tasks2 isAdmin={isAdmin} />
              </ProtectedRouteUser>
            )
          } 
        />
        
        <Route 
          path="notes" 
          element={
            isAdmin ? (
              <MentorNotes2 isAdmin={isAdmin} menteeId={viewingMenteeId} />
            ) : (
              <ProtectedRouteUser requiredSubscription="step2_mentorship">
                <MentorNotes2 isAdmin={isAdmin} />
              </ProtectedRouteUser>
            )
          } 
        />
        
        <Route 
          path="checklist" 
          element={
            isAdmin ? (
              <Checklist2 isAdmin={isAdmin} menteeId={viewingMenteeId} />
            ) : (
              <ProtectedRouteUser requiredSubscription="step2_mentorship">
                <Checklist2 isAdmin={isAdmin} />
              </ProtectedRouteUser>
            )
          } 
        />
        
        <Route 
          path="plan" 
          element={
            isAdmin ? (
              <Dedicated2 isAdmin={isAdmin} menteeId={viewingMenteeId} />
            ) : (
              <ProtectedRouteUser requiredSubscription="step2_mentorship">
                <Dedicated2 isAdmin={isAdmin} />
              </ProtectedRouteUser>
            )
          } 
        />
        
        <Route 
          path="meetings" 
          element={
            isAdmin ? (
              <MenteeMeetings2 isAdmin={isAdmin} menteeId={viewingMenteeId} />
            ) : (
              <ProtectedRouteUser requiredSubscription="step2_mentorship">
                <MenteeMeetings2 isAdmin={isAdmin} />
              </ProtectedRouteUser>
            )
          } 
        />
        
        <Route 
          path="weakspots" 
          element={
            isAdmin ? (
              <WeakSpots2 isAdmin={isAdmin} menteeId={viewingMenteeId} />
            ) : (
              <ProtectedRouteUser requiredSubscription="step2_mentorship">
                <WeakSpots2 isAdmin={isAdmin} />
              </ProtectedRouteUser>
            )
          } 
        />
        
        <Route 
          path="assignments" 
          element={
            isAdmin ? (
              <Assignments2 isAdmin={isAdmin} menteeId={viewingMenteeId} />
            ) : (
              <ProtectedRouteUser requiredSubscription="step2_mentorship">
                <Assignments2 isAdmin={isAdmin} />
              </ProtectedRouteUser>
            )
          } 
        />

        {/* # Add new routes */}
        <Route 
          path="give-assignment" 
          element={
            isAdmin ? (
              <ProtectedRouteAdmin>
                <GiveAssignment2 isAdmin={isAdmin} menteeId={viewingMenteeId} />
              </ProtectedRouteAdmin>
            ) : (
              <ProtectedRouteUser requiredSubscription="step2_mentorship">
                <GiveAssignment2 isAdmin={isAdmin} />
              </ProtectedRouteUser>
            )
          } 
        />
        
        <Route 
          path="dedicated-tasks" 
          element={
            isAdmin ? (
              <ProtectedRouteAdmin>
                <DedicatedTasks2 isAdmin={isAdmin} menteeId={viewingMenteeId} />
              </ProtectedRouteAdmin>
            ) : (
              <ProtectedRouteUser requiredSubscription="step2_mentorship">
                <DedicatedTasks2 isAdmin={isAdmin} />
              </ProtectedRouteUser>
            )
          } 
        />
        
        {/* # Add Mentee Guide route */}
        <Route 
          path="mentee-guide" 
          element={
            isAdmin ? (
              <MenteeGuide isAdmin={isAdmin} stepType="2" menteeId={viewingMenteeId} />
            ) : (
              <ProtectedRouteUser requiredSubscription="step2_mentorship">
                <MenteeGuide isAdmin={isAdmin} stepType="2" />
              </ProtectedRouteUser>
            )
          } 
        />

        {/* # Add Calendar route */}
        <Route 
          path="calendar" 
          element={
            isAdmin ? (
              <ProtectedRouteAdmin>
                <M2Calendar isAdmin={isAdmin} menteeId={viewingMenteeId} />
              </ProtectedRouteAdmin>
            ) : (
              <ProtectedRouteUser requiredSubscription="step2_mentorship">
                <M2Calendar isAdmin={isAdmin} />
              </ProtectedRouteUser>
            )
          } 
        />

        {/* # Add Time route */}
        <Route 
          path="time" 
          element={
            isAdmin ? (
              <ProtectedRouteAdmin>
                <NeoTime stepType="Step 2" menteeId={viewingMenteeId} />
              </ProtectedRouteAdmin>
            ) : (
              <ProtectedRouteUser requiredSubscription="step2_mentorship">
                <NeoTime stepType="Step 2" />
              </ProtectedRouteUser>
            )
          } 
        />

        {/* # Add Counter routes */}
        <Route 
          path="mentoring2/counter2" 
          element={
            isAdmin ? (
              <ProtectedRouteAdmin>
                <Counter2 isAdmin={isAdmin} menteeId={viewingMenteeId} />
              </ProtectedRouteAdmin>
            ) : (
              <ProtectedRouteUser requiredSubscription="step2_mentorship">
                <Counter2 isAdmin={isAdmin} />
              </ProtectedRouteUser>
            )
          } 
        />

        <Route 
          path="mentoring2/counter2/:chapterId" 
          element={
            isAdmin ? (
              <ProtectedRouteAdmin>
                <Counter2Page isAdmin={isAdmin} menteeId={viewingMenteeId} />
              </ProtectedRouteAdmin>
            ) : (
              <ProtectedRouteUser requiredSubscription="step2_mentorship">
                <Counter2Page isAdmin={isAdmin} />
              </ProtectedRouteUser>
            )
          } 
        />

        {/* # Add TaskChapter2 route */}
        <Route 
          path="tutora2/chapter/:chapterId" 
          element={
            isAdmin ? (
              <ProtectedRouteAdmin>
                <TaskChapter2 isAdmin={isAdmin} menteeId={viewingMenteeId} />
              </ProtectedRouteAdmin>
            ) : (
              <ProtectedRouteUser requiredSubscription="step2_mentorship">
                <TaskChapter2 isAdmin={isAdmin} />
              </ProtectedRouteUser>
            )
          } 
        />
      </Routes>
    </div>
  );
}

export default NeoMenteeStep2;